export const checkinModalConversation = {
  guestFallback: "Ospite",
  conversationLabel: "Conversazione:",
  replyOnWhatsAppLabel: "Rispondi su WhatsApp:",
  replyOnWhatsAppTooltip: "Rispondi su WhatsApp",
};
